__turbopack_context__.v({
  "heading": "styles-module__IV3FPG__heading",
  "wrapper": "styles-module__IV3FPG__wrapper",
});
